import MainLayout from '@/common/components/layouts/MainLayout';
import ImagesFabMainModal from '@/modules/adjusterReportModules/adjusterReport/components/imagesFab/ImagesFabMainModal';
import Stepper from '@/modules/adjusterReportModules/IncidentParticipants/components/common/Stepper';
import { culpritStepDriverData } from '@/modules/adjusterReportModules/IncidentParticipants/data/stepsData';
import { getCulpritDriverInfoQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/getculpritDriverInfo/getCulpritDriverInfoQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { PropsWithChildren, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

export default ({ children }: PropsWithChildren) => {
  return (
    <MainLayout title="مقصر / راننده" header="closeHeader">
      <CulpritDriverInfo>{children}</CulpritDriverInfo>
    </MainLayout>
  );
};
const CulpritDriverInfo = ({ children }: PropsWithChildren) => {
  const methods = useForm({
    mode: 'onChange',
  });
  const { id } = useParams();
  const { data: culpritDriverInfo } = useQuery(
    getCulpritDriverInfoQueryOptions({ id: +id! }),
  );
  useEffect(() => {
    if (culpritDriverInfo) methods.reset(culpritDriverInfo);
  }, [culpritDriverInfo]);

  return (
    <>
      <Box width="100%" pt={'24px'}>
        <Stepper steps={culpritStepDriverData} width="80%" />
      </Box>
      <Box
        w="100%"
        mx="auto"
        mt={40}
        mb={24}
        border="1px solid"
        borderColor="gray-2"
      ></Box>
      <Box width="100%">
        <FormProvider {...methods}>{children}</FormProvider>
      </Box>
      <ImagesFabMainModal state={'propertyCulprit'} />
    </>
  );
};
